import { render, staticRenderFns } from "./storeSelfGoods.vue?vue&type=template&id=13f8f320&"
import script from "./storeSelfGoods.vue?vue&type=script&lang=js&"
export * from "./storeSelfGoods.vue?vue&type=script&lang=js&"
import style0 from "./storeSelfGoods.vue?vue&type=style&index=0&id=13f8f320&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports